
const newrelicReportingPlugin = require('@nc_ui/ilc-plugin-reporting-newrelic/browser');
const transitionHooksPlugin = require('@nc_ui/ilc-plugin-transition-hooks-spaceship/browser');

module.exports = {
    manifest: {
        plugins: [ newrelicReportingPlugin, transitionHooksPlugin ],
    },
};
